// extracted by mini-css-extract-plugin
export default {"mobileModal":"domHeaderSettings_mobileModal__JlIHN","colorPickerOverlayBg":"domHeaderSettings_colorPickerOverlayBg__FeGEC"};